export enum KYCStatusEnum {
  PENDING_SUBMISSION = 'pending_submission',
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  OUTDATED = 'outdated',
  DRAFT = 'draft',
  DEPRECATED = 'expired',
}
